import * as React from "react";
import { forwardRef } from "react";
const SvgIconMinus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 12C6 11.586 6.336 11.25 6.75 11.25H17.25C17.664 11.25 18 11.586 18 12C18 12.414 17.664 12.75 17.25 12.75H6.75C6.336 12.75 6 12.414 6 12Z", fill: "black" }));
const ForwardRef = forwardRef(SvgIconMinus);
export default ForwardRef;
